
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import licenseAgreementHtml from '!raw-loader!@/assets/html/License-agreement.html';

@Component
export default class TermsConditions extends Vue {
    licenseAgreementHtml: string = licenseAgreementHtml;
}
